import {X} from 'lucide-react';
import {useIntl} from 'react-intl';
import {insightsMessages as m} from './insightsMessages';
import {iconButton, lucide} from './insightsUi';

const Keys = ({keys}: {keys: string[]}) => (
    <span className="inline-flex shrink-0 items-center gap-1">
        {keys.map((key) => (
            <kbd key={key} className="inline-flex h-6 min-w-6 items-center justify-center rounded-badge border border-solid border-line bg-surface-muted px-1.5 font-sans text-micro text-ink-secondary">
                {key}
            </kbd>
        ))}
    </span>
);

export const ShortcutsHelp = ({askEnabled, onClose}: {askEnabled: boolean; onClose: () => void}) => {
    const intl = useIntl();
    const rows: [string[], string][] = [
        [['K', 'Space'], intl.formatMessage(m.helpPlayPause)],
        [['J', 'L', '←', '→'], intl.formatMessage(m.helpSkip)],
        [['/'], intl.formatMessage(m.helpSearch)],
        [['N', '⇧N'], intl.formatMessage(m.helpMatches)],
        askEnabled ? [['1', '2', '3'], intl.formatMessage(m.helpTabs)] : [['1', '2'], intl.formatMessage(m.helpTabsWithoutAsk)],
        [['?'], intl.formatMessage(m.helpHelp)],
        [['Esc'], intl.formatMessage(m.helpClose)],
    ];
    return (
        <section
            aria-labelledby="insights-shortcuts-title"
            data-testid="insights-shortcuts"
            className="absolute right-4 top-14 z-20 w-[300px] rounded-card bg-surface p-4 shadow-menu motion-safe:animate-insights-pop-in"
        >
            <div className="mb-2 flex items-center justify-between">
                <h3 id="insights-shortcuts-title" className="m-0 text-callout font-semibold text-ink">{intl.formatMessage(m.helpTitle)}</h3>
                <button type="button" aria-label={intl.formatMessage(m.close)} onClick={onClose} className={`${iconButton} size-7`}>
                    <X size={16} aria-hidden="true" className={lucide}/>
                </button>
            </div>
            <dl className="m-0 flex flex-col gap-2">
                {rows.map(([keys, label]) => (
                    <div key={label} className="flex items-center justify-between gap-3">
                        <dt className="text-footnote text-ink-secondary">{label}</dt>
                        <dd className="m-0"><Keys keys={keys}/></dd>
                    </div>
                ))}
            </dl>
        </section>
    );
};
